import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
  Grid,
} from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
  MasterButton,
  ModalHistory,
} from "App/Component/ui";
import { RenderStatusVerifikasiBadge as StatusTransaksi } from "../../DaftarRequestFixedAsset/helpers";
import { useDatatables } from "App/hooks";
import { defaultDateDisplay, isNull } from "App/utils/helpers"; // eslint-disable-line
import React, { useState, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "../context/FormContext";
import {
  FORM_RESET_BARANG,
  FORM_RESET_STATE_WMS_REQ,
  STATUS_BARANG_OK,
  STATUS_BARANG_PENGAJUAN,
  STATUS_BARANG_TOLAK,
  // STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_DRAFT,
  STATUS_TRANSAKSI_REVISI,
  // STATUS_TRANSAKSI_PENGAJUAN,
} from "../helpers";
import { headCells } from "../helpers";
import {
  ModalBarang,
  ModalSimpan,
  FormImportTOR,
  // ModalHistory,
} from ".";
import { trim } from "lodash";
import { getUserName } from "App/utils/cookies";
export default function RenderListReq({
  classes,
  setNewDataReqList,
  namaInputRef,
}) {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [formBarang, setFormBarang] = useState(FORM_RESET_BARANG);
  const { setFormData, listREQ, setListREQ } = useContext(FormContext);
  // const { validasi } = useContext(FormContext);
  const [file, setFile] = useState(null);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listREQ,
    orderByDefault: "name_barang",
    orderByRow: ["name_barang"],
  });
  const {
    formData,
    showModalBarang,
    setShowModalBarang,
    showModalHistory,
    setShowModalHistory,
  } = useContext(FormContext);
  const [showModalSimpan, setShowModalSimpan] = useState(false);

  async function deleteList() {
    const barang = listREQ;
    let checkBarang = [];
    if (isNull(formBarang.id)) {
      checkBarang = barang.filter(
        (e) => e.name_barang !== formBarang.name_barang
      );
    } else {
      checkBarang = barang.filter((e) => e.id !== formBarang.id);
    }
    setListREQ(checkBarang);
    setShowModalDeleteConfirm(false);
  }

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormBarang({
      ...formBarang,
      id: row?.id,
      name_barang: trim(row?.name_barang),
    });
  };

  const handleClickUpdate = async (row) => {
    await setFormBarang({
      id: row?.id,
      name_barang: trim(row?.name_barang),
      name_barang2: trim(row?.name_barang),
      namasatuan: row?.namasatuan,
      namagolongan: row?.namagolongan,
      satuan_id: row?.satuan_id,
      golongan_id: row?.golongan_id,
      qty: row.qty,
      remark: row?.remark,
      status_cek_barang: null,
      keterangan_cek_barang: row?.keterangan_cek_barang,
      user_cek_barang: row?.user_cek_barang,
      dateCek: row?.dateCek,
      onCreate: false,
    });
    namaInputRef?.current?.focus();
    setShowModalBarang(!showModalBarang);
  };

  const handleClickTambah = () => {
    setShowModalBarang(!showModalBarang);
    setFormBarang(FORM_RESET_BARANG);
    namaInputRef?.current?.focus();
  };

  const handleClickHistory = () => {
    setShowModalHistory(!showModalHistory);
  };

  const handleReset = () => {
    setFormData(FORM_RESET_STATE_WMS_REQ);
    setFormBarang(FORM_RESET_BARANG);
    setListREQ([]);
    // setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
  };

  return (
    <>
      {showModalBarang && (
        <ModalBarang
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewDataReqList={setNewDataReqList}
          setListREQ={setListREQ}
          listREQ={listREQ}
          namaInputRef={namaInputRef}
        />
      )}
      {showModalHistory && (
        <ModalHistory
          title={"History Request"}
          id={formData?.idreq}
          showModal={setShowModalHistory}
          url={"/wmsAsset/request/list_histori_req"}
        />
      )}
      {showModalSimpan && (
        <ModalSimpan
          setShowModal={() => setShowModalSimpan(false)}
          resetForm={() => handleReset()}
          setNewDataReqList={setNewDataReqList}
          listREQ={listREQ}
          setListREQ={setListREQ}
        />
      )}
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <div className='mb-1'>
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
          }}>
          {formData.idreq !== "" && (
            <>
              <p className='fw-600 mr-1'>Status : </p>
              <StatusTransaksi status={formData.status_verifikasi} />
            </>
          )}
        </div>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <h5 className='fw-600'>Data Barang Request</h5>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}>
            <MasterButton
              onClick={isNull(formData.idreq) ? null : handleClickHistory}
              disabled={false}
              className={"mt-1"}
              type={"button"}
              color={isNull(formData.idreq) ? "secondary" : "lightgreen"}
              name='History Request'
              size='md'
            />
            <MasterButton
              onClick={
                formData.status_verifikasi === STATUS_TRANSAKSI_REVISI &&
                formData.user_request === getUserName()
                  ? handleClickTambah
                  : formData.status_verifikasi === STATUS_TRANSAKSI_DRAFT
                  ? handleClickTambah
                  : null
              }
              disabled={false}
              className={"mt-1"}
              type={"button"}
              color={
                formData.status_verifikasi === STATUS_TRANSAKSI_REVISI &&
                formData.user_request === getUserName()
                  ? "green"
                  : formData.status_verifikasi === STATUS_TRANSAKSI_DRAFT
                  ? "green"
                  : "secondary"
              }
              name='Tambah Barang'
              size='md'
            />
          </div>
        </Grid>
      </div>
      <TableContainer className='custom-scrollbar'>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {formData.isProcess && (
                        <>
                          {/* {formData.status_verifikasi ===
                            STATUS_TRANSAKSI_DISETUJUI && validasi ? (
                            <IconButtonDatatable
                              onClick={() => handleClickVerifikasi(row)}
                            >
                              <SelectIcon />
                            </IconButtonDatatable>
                          ) : (
                            <></>
                          )} */}
                        </>
                      )}
                      {!formData.isProcess &&
                      formData.user_request === getUserName() ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}>
                          <IconButtonDatatable
                            onClick={() => handleClickUpdate(row)}>
                            <PencilIcon />
                          </IconButtonDatatable>

                          <IconButtonDatatable
                            onClick={() => handleClickDelete(row)}>
                            <TrashIcon />
                          </IconButtonDatatable>
                        </div>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <RenderTableCell row={row} />
                  </TableRow>
                );
              })}
            {listREQ.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'>
        <MasterButton
          className={"mt-1"}
          type='button'
          color={"danger"}
          outline={true}
          name={"RESET"}
          onClick={() => handleReset()}
          size='md'
        />

        <div>
          <MasterButton
            type={"button"}
            color='green'
            name='Simpan'
            size='lg'
            onClick={() => setShowModalSimpan(!showModalSimpan)}
          />
        </div>
      </Grid>

      <div className='mt-2'>
        <FormImportTOR
          file={file}
          setFile={setFile}
          setNewDataReqList={setNewDataReqList}
        />
      </div>
    </>
  );
}

const RenderStatusVerifikasiBadge = ({ status }) => {
  // eslint-disable-line
  if (status === STATUS_BARANG_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN"}
        color={"secondary"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_BARANG_OK) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"OK"}
        color={"green"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_BARANG_TOLAK) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Ditolak"}
        color={"danger"}
        type='button'
        disabled
      />
    );
  } else {
    return <p>-</p>;
  }
};

const RenderTableCell = ({ row }) => {
  return (
    <>
      <TableCell align='left'>{row?.id}</TableCell>
      <TableCell align='left'>{row?.name_barang}</TableCell>
      <TableCell align='left'>{row?.namasatuan}</TableCell>
      <TableCell align='left'>{row.qty}</TableCell>
      {/* <TableCell align="left">{row?.namagolongan}</TableCell> */}
      <TableCell align='left'>
        {isNull(row?.remark) ? "-" : row?.remark}
      </TableCell>
      <TableCell align='center'>
        <RenderStatusVerifikasiBadge status={row?.status_cek_barang} />
      </TableCell>
      <TableCell align='left'>
        {row?.keterangan_cek_barang === null ? "-" : row?.keterangan_cek_barang}
      </TableCell>
      <TableCell align='left'>
        {row?.user_cek_barang === null ? "-" : row?.user_cek_barang}
      </TableCell>
      <TableCell align='left'>
        {row?.dateCek === null ? "-" : defaultDateDisplay(row.dateCek, true)}
      </TableCell>
    </>
  );
};
